import { render } from "./PersonalInfos.vue?vue&type=template&id=80cb7d22&scoped=true"
import script from "./PersonalInfos.vue?vue&type=script&lang=js"
export * from "./PersonalInfos.vue?vue&type=script&lang=js"

import "./PersonalInfos.vue?vue&type=style&index=0&id=80cb7d22&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80cb7d22"]])

export default __exports__